export default __webpack_public_path__ + "static/media/banner.16632fea.mp4";